// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const karrablast: PokeData = {
  "id": 588,
  "name": "karrablast",
  "height": 5,
  "weight": 59,
  "base_experience": 63,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "swords-dance",
    "headbutt",
    "fury-attack",
    "take-down",
    "double-edge",
    "leer",
    "peck",
    "slash",
    "flail",
    "scary-face",
    "endure",
    "false-swipe",
    "fury-cutter",
    "x-scissor",
    "bug-buzz",
    "acid-spray"
  ],
  "moves": [
    "headbutt",
    "leer",
    "peck",
    "scary-face",
    "bug-buzz",
    "pin-rush",
    "infest",
    "pin-missile",
    "lunge",
    "bug-bite",
    "string-shot",
    "sticky-web",
    "pounce"
  ],
  "evolution_chain": {
    "id": 299,
    "item": null,
    "species": [
      {
        "name": "karrablast",
        "order": 589,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "escavalier",
        "order": 590,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 588,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": 616,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 60,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
